import styled from "styled-components"
import { X } from "lucide-react"
import { motion } from "framer-motion"
import { useState } from "react"


const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`




const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`
const ColorInput = styled(Input)`
  height: 40px;
  padding: 5px;
`

const ModalContent = styled(motion.div)`
  background-color: #2A2B2E;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const ModalTitle = styled.h2`
  color: #FFFFFF;
  margin: 0;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 1.5rem;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  color: #FFFFFF;
  font-size: 0.9rem;
`

export function WebModal({ setIsAddModalOpen, onAddImage }){
    
    const [newImage, setNewImage] = useState({
        url: "",
        color: ""
    })
    function handleAddImage(e){
        e.preventDefault()
        console.log(newImage)
        onAddImage({image: newImage})
    }
    return (
<ModalOverlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
<ModalContent
  initial={{ scale: 0.9, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  exit={{ scale: 0.9, opacity: 0 }}
>
  <ModalHeader>
    <ModalTitle>Añadir Imagen</ModalTitle>
    <CloseButton onClick={() => setIsAddModalOpen(false)}>
      <X size={24} />
    </CloseButton>
  </ModalHeader>
  <Form onSubmit={handleAddImage}>
    <FormGroup>
      <Label htmlFor="imageUrl">URL de la imagen</Label>
      <Input
        id="imageUrl"
        type="file"
        // value={newImage.url}
        onChange={(e) => setNewImage({ ...newImage, url: e.target.files[0] })}
        required
      />
    </FormGroup>
      <Label htmlFor="imageColor">Color</Label>
      <ColorInput
        id="imageColor"
        type="color"
        value={newImage.color}
        onChange={(e) => setNewImage({ ...newImage, color: e.target.value })}
      />
    <Button type="submit">Añadir Imagen</Button>
  </Form>
</ModalContent>
</ModalOverlay>
    )
}

